// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2025-05-22T09:54:31Z                      #

// ##############################################################

// @ts-ignore - not used import
import {AxiosInstance, AxiosResponse, AxiosRequestConfig, CancelToken} from 'axios';
// @ts-ignore - not used import
import {unwrapResponse, generateUrl, baseAxios} from '@mc/axios-api';
// @ts-ignore - not used import
import * as importUrl from 'url';
// @ts-ignore - not used import
import ConfigurationVO from "./types/ConfigurationVO";
// @ts-ignore - not used import
import FlowConfigurationVO from "./types/FlowConfigurationVO";
// @ts-ignore - not used import
import RequestSignerVO from "./types/RequestSignerVO";
// @ts-ignore - not used import
import ApprovalVO from "./types/ApprovalVO";

// @ts-ignore - not used import
import * as UpdateMethods from "./UpdateMethods";


// @ts-ignore - not used import
type SimpleHeaders = {[key: string]: string};

/**
 *  Generated from cz.marbes.qsign.controller.QSignPracovnikController.
 */
export default class QSignPracovnikApi {
    /**
     * 
     *
     * @return 
     */
    static findAllPersons(config?: {cancelToken?: CancelToken}) : Promise<any> {
        return unwrapResponse<any>(QSignPracovnikApi.raw.findAllPersons(config));
    }
    /**
     * Získání platných konfigurací.
     *
     * @return 
     */
    static findConfigurations(config?: {cancelToken?: CancelToken}) : Promise<ConfigurationVO[]> {
        return unwrapResponse<ConfigurationVO[]>(QSignPracovnikApi.raw.findConfigurations(config));
    }
    /**
     * 
     *
     * @return 
     */
    static findApprovalConfigs(config?: {cancelToken?: CancelToken}) : Promise<FlowConfigurationVO[]> {
        return unwrapResponse<FlowConfigurationVO[]>(QSignPracovnikApi.raw.findApprovalConfigs(config));
    }
    /**
     * 
     *
     * @return 
     */
    static findAllSigners(config?: {cancelToken?: CancelToken}) : Promise<any> {
        return unwrapResponse<any>(QSignPracovnikApi.raw.findAllSigners(config));
    }
    /**
     * 
     *
     * @param requestId 
     * @return 
     */
    static findRequestApproval(requestId : number, config?: {cancelToken?: CancelToken}) : Promise<ApprovalVO> {
        return unwrapResponse<ApprovalVO>(QSignPracovnikApi.raw.findRequestApproval(requestId, config));
    }
    /**
     * 
     *
     * @return 
     */
    static findAllReqestPersons(config?: {cancelToken?: CancelToken}) : Promise<any> {
        return unwrapResponse<any>(QSignPracovnikApi.raw.findAllReqestPersons(config));
    }
    /**
     * 
     *
     * @param requestId 
     * @return 
     */
    static findRequestSigners(requestId : number, config?: {cancelToken?: CancelToken}) : Promise<RequestSignerVO[]> {
        return unwrapResponse<RequestSignerVO[]>(QSignPracovnikApi.raw.findRequestSigners(requestId, config));
    }
    /**
     * 
     *
     * @return 
     */
    static findAllActive(config?: {cancelToken?: CancelToken}) : Promise<any> {
        return unwrapResponse<any>(QSignPracovnikApi.raw.findAllActive(config));
    }

    static raw = {
            findAllPersons: function(config?: AxiosRequestConfig, axiosInstance: AxiosInstance = baseAxios): Promise<AxiosResponse<any>> {
                const uri = `/qsign/api/pracovnik`;
                const headers : SimpleHeaders = {};
                headers['Content-Type'] = 'application/json';

                const params = {  };
                 

                const finalUri = params && Object.keys(params).length > 0 ? uri + importUrl.format({query: params}) : uri;

                let finalHeaders;
                if (config && config.headers) {
                    finalHeaders = {
                        ...(headers || {}),
                        ...config.headers
                    };
                } else {
                    finalHeaders = headers;
                }

                const finalConfig = {
                    ...config,
                    headers: finalHeaders
                }


                return axiosInstance.get<any, AxiosResponse<any>>(finalUri, finalConfig);
            },
            findConfigurations: function(config?: AxiosRequestConfig, axiosInstance: AxiosInstance = baseAxios): Promise<AxiosResponse<ConfigurationVO[]>> {
                const uri = `/qsign/api/configurations`;
                const headers : SimpleHeaders = {};
                headers['Content-Type'] = 'application/json';

                const params = {  };
                 

                const finalUri = params && Object.keys(params).length > 0 ? uri + importUrl.format({query: params}) : uri;

                let finalHeaders;
                if (config && config.headers) {
                    finalHeaders = {
                        ...(headers || {}),
                        ...config.headers
                    };
                } else {
                    finalHeaders = headers;
                }

                const finalConfig = {
                    ...config,
                    headers: finalHeaders
                }


                return axiosInstance.get<any, AxiosResponse<ConfigurationVO[]>>(finalUri, finalConfig);
            },
            findApprovalConfigs: function(config?: AxiosRequestConfig, axiosInstance: AxiosInstance = baseAxios): Promise<AxiosResponse<FlowConfigurationVO[]>> {
                const uri = `/qsign/api/configurations/approval`;
                const headers : SimpleHeaders = {};
                headers['Content-Type'] = 'application/json';

                const params = {  };
                 

                const finalUri = params && Object.keys(params).length > 0 ? uri + importUrl.format({query: params}) : uri;

                let finalHeaders;
                if (config && config.headers) {
                    finalHeaders = {
                        ...(headers || {}),
                        ...config.headers
                    };
                } else {
                    finalHeaders = headers;
                }

                const finalConfig = {
                    ...config,
                    headers: finalHeaders
                }


                return axiosInstance.get<any, AxiosResponse<FlowConfigurationVO[]>>(finalUri, finalConfig);
            },
            findAllSigners: function(config?: AxiosRequestConfig, axiosInstance: AxiosInstance = baseAxios): Promise<AxiosResponse<any>> {
                const uri = `/qsign/api/pracovnik/sign`;
                const headers : SimpleHeaders = {};
                headers['Content-Type'] = 'application/json';

                const params = {  };
                 

                const finalUri = params && Object.keys(params).length > 0 ? uri + importUrl.format({query: params}) : uri;

                let finalHeaders;
                if (config && config.headers) {
                    finalHeaders = {
                        ...(headers || {}),
                        ...config.headers
                    };
                } else {
                    finalHeaders = headers;
                }

                const finalConfig = {
                    ...config,
                    headers: finalHeaders
                }


                return axiosInstance.get<any, AxiosResponse<any>>(finalUri, finalConfig);
            },
            findRequestApproval: function(requestId : number, config?: AxiosRequestConfig, axiosInstance: AxiosInstance = baseAxios): Promise<AxiosResponse<ApprovalVO>> {
                const uri = `/qsign/api/pracovnik/requestApproval`;
                const headers : SimpleHeaders = {};
                headers['Content-Type'] = 'application/json';

                const params = { requestId };
                 

                const finalUri = params && Object.keys(params).length > 0 ? uri + importUrl.format({query: params}) : uri;

                let finalHeaders;
                if (config && config.headers) {
                    finalHeaders = {
                        ...(headers || {}),
                        ...config.headers
                    };
                } else {
                    finalHeaders = headers;
                }

                const finalConfig = {
                    ...config,
                    headers: finalHeaders
                }


                return axiosInstance.post<any, AxiosResponse<ApprovalVO>>(finalUri, 0, finalConfig);
            },
            findAllReqestPersons: function(config?: AxiosRequestConfig, axiosInstance: AxiosInstance = baseAxios): Promise<AxiosResponse<any>> {
                const uri = `/qsign/api/pracovnik/request`;
                const headers : SimpleHeaders = {};
                headers['Content-Type'] = 'application/json';

                const params = {  };
                 

                const finalUri = params && Object.keys(params).length > 0 ? uri + importUrl.format({query: params}) : uri;

                let finalHeaders;
                if (config && config.headers) {
                    finalHeaders = {
                        ...(headers || {}),
                        ...config.headers
                    };
                } else {
                    finalHeaders = headers;
                }

                const finalConfig = {
                    ...config,
                    headers: finalHeaders
                }


                return axiosInstance.get<any, AxiosResponse<any>>(finalUri, finalConfig);
            },
            findRequestSigners: function(requestId : number, config?: AxiosRequestConfig, axiosInstance: AxiosInstance = baseAxios): Promise<AxiosResponse<RequestSignerVO[]>> {
                const uri = `/qsign/api/pracovnik/requestSigners`;
                const headers : SimpleHeaders = {};
                headers['Content-Type'] = 'application/json';

                const params = { requestId };
                 

                const finalUri = params && Object.keys(params).length > 0 ? uri + importUrl.format({query: params}) : uri;

                let finalHeaders;
                if (config && config.headers) {
                    finalHeaders = {
                        ...(headers || {}),
                        ...config.headers
                    };
                } else {
                    finalHeaders = headers;
                }

                const finalConfig = {
                    ...config,
                    headers: finalHeaders
                }


                return axiosInstance.post<any, AxiosResponse<RequestSignerVO[]>>(finalUri, 0, finalConfig);
            },
            findAllActive: function(config?: AxiosRequestConfig, axiosInstance: AxiosInstance = baseAxios): Promise<AxiosResponse<any>> {
                const uri = `/qsign/api/pracovnik/active`;
                const headers : SimpleHeaders = {};
                headers['Content-Type'] = 'application/json';

                const params = {  };
                 

                const finalUri = params && Object.keys(params).length > 0 ? uri + importUrl.format({query: params}) : uri;

                let finalHeaders;
                if (config && config.headers) {
                    finalHeaders = {
                        ...(headers || {}),
                        ...config.headers
                    };
                } else {
                    finalHeaders = headers;
                }

                const finalConfig = {
                    ...config,
                    headers: finalHeaders
                }


                return axiosInstance.get<any, AxiosResponse<any>>(finalUri, finalConfig);
            },
    }
}
